import { render, staticRenderFns } from "./EstablishmentRoleDelete.vue?vue&type=template&id=cb81f7c2&scoped=true&"
import script from "./EstablishmentRoleDelete.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb81f7c2",
  null
  
)

export default component.exports